import React from "react";
import {
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  Box,
  Divider,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import GroupIcon from "@mui/icons-material/Group";

const Informate = ({ handleClose }) => {
  return (
    <Container maxWidth="md" sx={{ mt: 2, textAlign: "center" }}>
      <Typography variant="h5" align="center" gutterBottom>
        INFORMATE
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Box
        component="img"
        src="../../assets/info.png"
        alt="Imagen de referencia"
        sx={{
          width: "15%",
          height: "auto",
        }}
      />
      <Typography variant="body1" align="center" gutterBottom>
        Recuerda que puedes acudir a CONATEL por los siguientes motivos:
      </Typography>

      <Grid container spacing={2} justifyContent="center" sx={{ mt: 1 }}>
        <Grid item xs={12} sm={4} display="flex" alignItems="center">
          <CheckCircleIcon color="success" sx={{ mr: 1 }} />
          <Typography>
            Si ya acudiste a la empresa prestadora del servicio y no dio
            respuesta a tu reclamo en los plazos establecidos.
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} display="flex" alignItems="center">
          <CheckCircleIcon color="success" sx={{ mr: 1 }} />
          <Typography>
            Si no estás conforme con la respuesta que la empresa te dio a tu
            reclamo.
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} display="flex" alignItems="center">
          <CheckCircleIcon color="success" sx={{ mr: 1 }} />
          <Typography>
            Para recibir asesoramiento sobre la prestación de los servicios de
            comunicaciones.
          </Typography>
        </Grid>
      </Grid>
      <Card sx={{ p: 2 }}>
        <CardContent>
          <Box display="flex" justifyContent="center">
            <InfoIcon color="primary" sx={{ fontSize: 50 }} />
          </Box>
          <Typography variant="body1">
            Para realizar una denuncia o reclamo ante CONATEL por inconvenientes
            con el servicio, ya sea por problemas técnicos, de facturación o
            administrativos, primero deberá presentar su reclamo ante el
            operador de servicio.
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Es importante saber que el proveedor de servicios de
            telecomunicaciones deberá ofrecerte una solución en primera
            instancia y en el caso de no estar satisfecho con los resultados
            obtenidos, puedes solicitar la intervención de CONATEL a través de
            una denuncia. La Unidad de Protección al Usuario te atenderá y
            contestará en menos de 10 días hábiles.
          </Typography>

          <Box display="flex" justifyContent="center" sx={{ mt: 3 }}>
            <GroupIcon color="primary" sx={{ fontSize: 50 }} />
          </Box>
          <Typography variant="body1" align="center" sx={{ mt: 2 }}>
            En esta sección encontrarás los datos, las referencias y requisitos
            solicitados por la empresa para efectuar su reclamo. Te recomendamos
            que el operador deba informarte la documentación que debe presentar
            según el tipo de reclamo, a fin de permitir el correcto análisis.
            También seleccionaremos el número de reclamo.
          </Typography>
        </CardContent>
      </Card>
      <Box display="flex" justifyContent="center" mt={2}>
        <Button variant="contained" color="primary" onClick={handleClose}>
          CERRAR
        </Button>
      </Box>
    </Container>
  );
};

export default Informate;
